module.exports=function(scope){ return `{"data":{"version":"8.x.x"},"meta":{"code":200,"message":"Server is running!","ok":true,"m":{"totalDurationInMS":35}}}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/test-connection.json.tpl